import { NavLink } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import {
  StyledPageHeading,
  StyledPageBody,
  StyledAccountContainer,
  StyledAccountLinksContainer,
  StyledAccountSection,
} from "../components/Styled";

const withAppHOC = (Component) => (props) => {
  return (
    <>
      <Header />
      <Component {...props} />
      <Footer />
    </>
  );
};

const withAccountHOC =
  (Component, { title }) =>
  (props) => {
    return (
      <>
        <StyledPageHeading>
          <h1>{title}</h1>
        </StyledPageHeading>
        <StyledPageBody>
          <StyledAccountContainer>
            <StyledAccountLinksContainer>
              <NavLink
                to="/profile"
                className={({ isActive }) => isActive && "active"}
                title="Profile"
              >
                Profile
              </NavLink>
              <NavLink
                to="/orders"
                className={({ isActive }) => isActive && "active"}
                title="Orders"
              >
                Orders
              </NavLink>
              <NavLink
                to="/addresses"
                className={({ isActive }) => isActive && "active"}
                title="Addresses"
              >
                Addresses
              </NavLink>
              <NavLink
                to="/change-password"
                className={({ isActive }) => isActive && "active"}
                title="Change Password"
              >
                Change Password
              </NavLink>
            </StyledAccountLinksContainer>
            <StyledAccountSection>
              <Component {...props} />
            </StyledAccountSection>
          </StyledAccountContainer>
        </StyledPageBody>
      </>
    );
  };

export { withAppHOC, withAccountHOC };
